import { faCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { ProgressBar } from 'react-bootstrap';
import './Skill.css';

const Skill = () => {
    const html = 98;
    const phpMysql = 90;
    const wordPress = 95;
    const lead = 99;
    const psdHtml = 99;
    const javaScript = 85;
    const react = 88;
    const node = 86;
    return (
        <div id="skill" className="bgBlack">
         <div className="triangles"> 
            </div>
           <div className="container mt-5">
           <h2 className="text-center mt-5 animate__animated animate__fadeInUp animate__delay-2s"><span>OUR STRONG</span> POINTS</h2>
            <p className="text-center animate__animated animate__fadeInUp animate__delay-2s text-white">Company strength at a Glance</p>
                <div className="separator text-center mb-5">
                    <span><FontAwesomeIcon icon={faCircle}/></span>
                </div>
               <div className="row d-flex">
               <div className="col-md-6 text-white mt-3">
                <p>We have a very strong team to create your web design using html & css.</p><br></br>
                <p>Our PHP Developer is very sincere & familiar.</p><br></br>
                <p>WordPress is our main Goal.we have suficient developer who are very expart in wordpress theme customisition & develoment.</p><br></br>
                <p>Lead Genaration also our second Goal.In our team some Frelancer in Upwork allready done 22,000 hr.</p><br></br>
                <p>We also provide PSD to HTML for our clients. Our designer done it in due time.</p><br></br>
                <p>We have Expart JavaScript Developer to build your site Static to Dynamic</p><br></br>
                <p>React is our main focas. We allready Developed 50+ project with React</p><br></br>
                <p>We use NODE Js for Backend. Its a very very important part of website.</p><br></br>
                </div>
                <div className="col-md-6">
                    <div>
                    <h6 className="text-white">HTML & CSS</h6>
                    <ProgressBar now={html} variant=""label={`${html}%`} />
                    </div><br></br>
                    <div>
                    <h6 className="text-white">PHP & MySql</h6>
                    <ProgressBar now={phpMysql} variant="" label={`${phpMysql}%`} />
                    </div><br></br>
                    <div>
                    <h6 className="text-white">WORDPRESS</h6>
                    <ProgressBar now={wordPress} variant="" label={`${wordPress}%`} />
                    </div><br></br>
                    <div>
                    <h6 className="text-white">LEAD Genaration</h6>
                    <ProgressBar now={lead} variant="" label={`${lead}%`} />
                    </div><br></br>
                    <div>
                    <h6 className="text-white">PSD to HTML</h6>
                    <ProgressBar now={psdHtml} variant="" label={`${psdHtml}%`} />
                    </div><br></br>
                    <div>
                    <h6 className="text-white">JAVASCRIPT</h6>
                    <ProgressBar now={javaScript} variant="" label={`${javaScript}%`} />
                    </div><br></br>
                    <div>
                    <h6 className="text-white">REACT.Js</h6>
                    <ProgressBar now={react} variant="" label={`${react}%`} />
                    </div><br></br>
                    <div>
                    <h6 className="text-white">NODE.Js</h6>
                    <ProgressBar now={node} variant="" label={`${node}%`} />
                    </div>
                </div>
               </div>
           </div>
            
        </div>
    );
};

export default Skill;
/*

                    
                    
                    
                    
                    
                    */